import applicationManagements from "./applicationManagements";

const applicationManagementService = [
    {
        matcher: 'applicationManagements',
        reply: config => {
            return [200, applicationManagements];
        }
    },
    {
        matcher: /applicationManagements\/(.*)/,
        reply: config => {
            const id = /applicationManagements\/(.*)/.exec(config.url)[1];
            const data = applicationManagements.find(item => item.uuid === id);
            return [200, data];
        }
    },
]

export default applicationManagementService;